const langAdminDocumentEmailNotifications = {
	title: {
		tag: 'admin.document_document_email_notifications.title',
		fr: 'Stats par document',
		en: 'Stats by document',
	},
	column_fund_name: {
		tag: 'admin.document_email_notifications.column_fund_name',
		fr: 'Nom du fonds',
		en: 'Fund name',
	},
	column_document_name: {
		tag: 'admin.document_email_notifications.column_document_name',
		fr: 'Nom du document',
		en: 'Document name',
	},
	column_nb_user_email: {
		tag: 'admin.document_email_notifications.column_nb_user_email',
		fr: 'Contacts',
		en: 'Contacts',
	},
	column_document_release_date: {
		tag: 'admin.document_email_notifications.column_document_release_date',
		fr: 'Date de sortie',
		en: 'Release date',
	},
	column_nb_user_email_to_send: {
		tag: 'admin.document_email_notifications.column_nb_user_email_to_send',
		fr: 'À envoyer',
		en: 'To send',
	},
	column_nb_user_email_in_progress: {
		tag: 'admin.document_email_notifications.column_nb_user_email_in_progress',
		fr: 'En cours',
		en: 'In progress',
	},
	column_nb_user_email_sent: {
		tag: 'admin.document_email_notifications.column_nb_user_email_sent',
		fr: 'Expédiés',
		en: 'Sent',
	},
	column_nb_user_email_bounced: {
		tag: 'admin.document_email_notifications.column_nb_user_email_bounced',
		fr: 'Rejetés',
		en: 'Bounced',
	},
	column_nb_user_email_error: {
		tag: 'admin.document_email_notifications.column_nb_user_email_error',
		fr: 'En échec',
		en: 'Error',
	},
	column_nb_user_email_undefined: {
		tag: 'admin.document_email_notifications.column_nb_user_email_undefined',
		fr: 'Non défini',
		en: 'Undefined',
	},
};

export default langAdminDocumentEmailNotifications;
